'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toHijri = undefined;

var _HijriDate = require('./HijriDate');

var _HijriDate2 = _interopRequireDefault(_HijriDate);

var _DateConverter = require('./DateConverter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toHijri = exports.toHijri = function toHijri(gregDate) {
  var _GregToHijri = (0, _DateConverter.GregToHijri)(gregDate),
      year = _GregToHijri.year,
      month = _GregToHijri.month,
      date = _GregToHijri.date;

  return new _HijriDate2.default(year, month, date, gregDate.getHours(), gregDate.getMinutes(), gregDate.getSeconds(), gregDate.getMilliseconds());
};
exports.default = _HijriDate2.default;